import React, { useState } from 'react'

const CostomTooltip = ({ text, position = "top", children, isDisabled }: any) => {

    const [isVisible, setIsVisible] = useState(false);

    const positionClasses: any = {
        top: "bottom-full md:left-[50%] left-[22%] transform md:-translate-x-[50%] -translate-x-[0] mb-2 w-40 md:w-40",
        bottom: "top-full left-1/2 transform -translate-x-1/2 mt-2 w-44 md:w-44 sm:w-24",
        left: "right-full top-1/2 transform -translate-y-1/2 mr-2 w-52 md:w-56 sm:w-24",
        right: "left-full top-1/2 transform -translate-y-1/2 ml-2 w-44 md:w-40 sm:w-24",
    };
    return (
        <div className="relative flex items-center w-auto">
            {/* Tooltip Content */}
            {isVisible && isDisabled && (
            <div
                className={`absolute bg-[#636363] text-white text-sm px-4 py-2 rounded-md shadow-md ${positionClasses[position]} 
                break-words z-30`}
            >
                {text}
                {/* Tail */}
                <div
                    className={`absolute w-3 h-3 bg-[#636363] transform rotate-45 ${position === "top"
                        ? "bottom-[-6px] md:left-1/2 -translate-x-1/2"
                        : position === "bottom"
                            ? "top-[-6px] left-1/2 -translate-x-1/2"
                            : position === "left"
                                ? "right-[-6px] top-1/2 -translate-y-1/2"
                                : "left-[-6px] top-1/2 -translate-y-1/2"
                        }`}
                />
            </div>
            )}

            {/* Children */}
            <div
                className={`cursor-pointer ${isDisabled ? "opacity-50" : ""
                    }`}
                onMouseEnter={() => {
                    if (isDisabled) {
                        setIsVisible(true);
                    }
                }}
                onMouseLeave={() => setIsVisible(false)}
            >
                {children}
            </div>
        </div>
    )
}

export default CostomTooltip;